import {t} from '@lingui/core/macro';

export type ExceededModalType = 'emails' | 'telegram_chats' | 'max_chats' | 'webhooks' | 'status_pages' | 'reports'
    | 'servers' | 'alert_rules' | 'domain_monitors' | 'port_monitors';

export type ExceededModalVariant = 'exceeded' | 'unavailable';

interface IExceededModalTexts {
    header: string,
    title: string,
    text: string,
}

const getExceededTexts = (type?: ExceededModalType): Omit<IExceededModalTexts, 'header'> => {
    switch (type) {
        case 'emails':
            return {
                title: t`Используется максимальное количество дополнительных E-mail для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные E-mail, перейдите на тариф с большими возможностями.`,
            };
        case 'telegram_chats':
            return {
                title: t`Используется максимальное количество Telegram-чатов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные Telegram-чаты, перейдите на тариф с большими возможностями.`,
            };
        case 'max_chats':
            return {
                title: t`Используется максимальное количество Max-чатов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные Max-чаты, перейдите на тариф с большими возможностями.`,
            };
        case 'webhooks':
            return {
                title: t`Используется максимальное количество вебхуков для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные вебхуки, перейдите на тариф с большими возможностями.`,
            };
        case 'status_pages':
            return {
                title: t`Используется максимальное количество страниц статуса для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные страницы статуса, перейдите на тариф с большими возможностями.`,
            };
        case 'reports':
            return {
                title: t`Используется максимальное количество отчётов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные отчёты, перейдите на тариф с большими возможностями.`,
            };
        case 'servers':
            return {
                title: t`Достигнут лимит серверов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные серверы, перейдите на тариф с большими возможностями.`,
            };
        case 'alert_rules':
            return {
                title: t`Достигнут лимит правил уведомлений для вашего тарифа.`,
                // eslint-disable-next-line max-len
                text: t`Чтобы добавить дополнительные правила уведомлений, перейдите на тариф с большими возможностями.`,
            };
        case 'domain_monitors':
            return {
                title: t`Достигнут лимит мониторов доменов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные мониторы доменов, перейдите на тариф с большими возможностями.`,
            };
        case 'port_monitors':
            return {
                title: t`Достигнут лимит мониторов портов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные мониторы портов, перейдите на тариф с большими возможностями.`,
            };
        default:
            return {
                title: t`Используется максимальное количество мониторов для вашего тарифа.`,
                text: t`Чтобы добавить дополнительные мониторы, перейдите на тариф с большими возможностями.`,
            };
    }
};

const getUnavailableTexts = (type?: ExceededModalType): Omit<IExceededModalTexts, 'header'> => {
    switch (type) {
        case 'emails':
            return {
                title: t`Дополнительные E-mail недоступны на вашем тарифе.`,
                text: t`Чтобы добавлять E-mail для уведомлений, перейдите на тариф с большими возможностями.`,
            };
        case 'telegram_chats':
            return {
                title: t`Telegram-чаты недоступны на вашем тарифе.`,
                text: t`Чтобы получать уведомления в Telegram, перейдите на тариф с большими возможностями.`,
            };
        case 'max_chats':
            return {
                title: t`Max-чаты недоступны на вашем тарифе.`,
                text: t`Чтобы получать уведомления в Max, перейдите на тариф с большими возможностями.`,
            };
        case 'webhooks':
            return {
                title: t`Вебхуки недоступны на вашем тарифе.`,
                text: t`Чтобы отправлять уведомления по вебхукам, перейдите на тариф с большими возможностями.`,
            };
        case 'status_pages':
            return {
                title: t`Страницы статуса недоступны на вашем тарифе.`,
                text: t`Чтобы публиковать страницы статуса, перейдите на тариф с большими возможностями.`,
            };
        case 'reports':
            return {
                title: t`Отчёты недоступны на вашем тарифе.`,
                text: t`Чтобы получать отчёты, перейдите на тариф с большими возможностями.`,
            };
        case 'servers':
            return {
                title: t`Мониторинг серверов недоступен на вашем тарифе.`,
                text: t`Чтобы следить за состоянием серверов, перейдите на тариф с большими возможностями.`,
            };
        case 'alert_rules':
            return {
                title: t`Правила уведомлений недоступны на вашем тарифе.`,
                text: t`Чтобы настраивать правила уведомлений, перейдите на тариф с большими возможностями.`,
            };
        case 'domain_monitors':
            return {
                title: t`Мониторы доменов недоступны на вашем тарифе.`,
                text: t`Чтобы следить за доменами, перейдите на тариф с большими возможностями.`,
            };
        case 'port_monitors':
            return {
                title: t`Мониторы портов недоступны на вашем тарифе.`,
                text: t`Чтобы следить за портами, перейдите на тариф с большими возможностями.`,
            };
        default:
            return {
                title: t`Мониторы сайтов недоступны на вашем тарифе.`,
                text: t`Чтобы следить за сайтами, перейдите на тариф с большими возможностями.`,
            };
    }
};

const getExceededModalTexts = (
    type?: ExceededModalType,
    variant: ExceededModalVariant = 'exceeded',
): IExceededModalTexts => {
    if (variant === 'unavailable') {
        return {
            header: t`Недоступно на вашем тарифе`,
            ...getUnavailableTexts(type),
        };
    }

    return {
        header: t`Лимит достигнут`,
        ...getExceededTexts(type),
    };
};

export default getExceededModalTexts;
